// ✨ UPDATED VERSION — ONLY EDIT EXISTING FIELDS ✨

import React, { useContext, useEffect, useState } from "react";
import api from "../../api";
import AuthContext from "../../context/AuthContext";

export default function AdminRoleResearch() {
  const { user } = useContext(AuthContext);
  const [papers, setPapers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPaper, setSelectedPaper] = useState(null);

  const [editPaper, setEditPaper] = useState(null);
  const [editTitle, setEditTitle] = useState("");
  const [editAbstract, setEditAbstract] = useState("");
  const [editKeywords, setEditKeywords] = useState("");
  const [editResearchers, setEditResearchers] = useState([]);
  const [editSections, setEditSections] = useState([]);

  const safeParse = (json) => {
    if (!json) return [];
    try {
      return JSON.parse(json);
    } catch {
      return [];
    }
  };

  const fetchMyPapers = async () => {
    try {
      const email = user.username;
      const userType = user.role === "ROLE_ADMIN" ? "ADMIN" : user.customerType;

      const res = await api.get("/api/research-papers/by-user", {
        params: { email, userType },
      });

      setPapers(res.data);
    } catch {
      console.error("Error fetching research papers");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) fetchMyPapers();
  }, [user]);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this research paper?")) return;

    const email = user.username;
    const userType = user.role === "ROLE_ADMIN" ? "ADMIN" : user.customerType;

    try {
      await api.delete(`/api/research-papers/delete-my-paper/${id}`, {
        params: { email, userType },
      });

      alert("Deleted!");
      fetchMyPapers();
    } catch {
      alert("Error deleting");
    }
  };

  // OPEN EDIT
  const openEditModal = (paper) => {
    setEditPaper(paper);
    setEditTitle(paper.title);
    setEditAbstract(paper.abstractText);
    setEditKeywords(paper.keywords);
    setEditResearchers(safeParse(paper.researchersJson));
    setEditSections(safeParse(paper.sectionsJson));
  };

  // SAVE EDIT
  const handleSaveEdit = async () => {
    const email = user.username;
    const userType = user.role === "ROLE_ADMIN" ? "ADMIN" : user.customerType;

    try {
      await api.put(
        `/api/research-papers/update-my-paper/${editPaper.id}`,
        {
          title: editTitle,
          abstractText: editAbstract,
          keywords: editKeywords,
          researchersJson: JSON.stringify(editResearchers),
          sectionsJson: JSON.stringify(editSections),
        },
        { params: { email, userType } }
      );

      alert("Updated Successfully!");
      setEditPaper(null);
      fetchMyPapers();
    } catch {
      alert("Update failed");
    }
  };

  if (loading) return <h3 className="text-center mt-5">Loading...</h3>;

  return (
    <div className="container my-4">
      <h3 className="fw-bold text-primary mb-4">📄 Your Research Papers</h3>

      <div className="row g-4">
        {papers.length > 0 ? (
          papers.map((p) => (
            <div key={p.id} className="col-md-6">
              <div className="card shadow-sm p-3 rounded-4">

                <h5 className="fw-semibold">{p.title}</h5>

                <p className="badge bg-info text-dark px-3 py-2">
                  Status: {p.status}
                </p>

                <p><b>Researchers:</b> {safeParse(p.researchersJson).length}</p>
                <p><b>Sections:</b> {safeParse(p.sectionsJson).length}</p>
                <div className="d-flex gap-2 mt-2">

                  <button
                    className="btn btn-outline-primary btn-sm rounded-pill"
                    data-bs-toggle="modal"
                    data-bs-target="#paperModal"
                    onClick={() => setSelectedPaper(p)}
                  >
                    👁 View
                  </button>

                  <button
                    className="btn btn-warning btn-sm rounded-pill"
                    onClick={() => openEditModal(p)}
                  >
                    ✏ Edit
                  </button>

                  <button
                    className="btn btn-danger btn-sm rounded-pill"
                    onClick={() => handleDelete(p.id)}
                  >
                    🗑 Delete
                  </button>

                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center text-muted">No research papers found</p>
        )}
      </div>

      {/* VIEW MODAL */}
      <div className="modal fade" id="paperModal" tabIndex="-1">
        <div className="modal-dialog modal-xl">
          <div className="modal-content rounded-4 shadow-lg">
            {selectedPaper && (
              <>
                <div className="modal-header bg-primary text-white">
                  <h5>{selectedPaper.title}</h5>
                  <button className="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                </div>

                <div className="modal-body" style={{ maxHeight: "75vh", overflowY: "auto" }}>
                  <h5>Abstract</h5>
                  <div dangerouslySetInnerHTML={{ __html: selectedPaper.abstractText }} />

                  <h5 className="mt-4">Keywords</h5>
                  <p>{selectedPaper.keywords}</p>

                  <h5 className="mt-4">Researchers</h5>
                  {safeParse(selectedPaper.researchersJson).map((r, i) => (
                    <p key={i}><b>{r.name}</b> — {r.qualification}</p>
                  ))}

                  <h5 className="mt-4">Sections</h5>
                  {safeParse(selectedPaper.sectionsJson).map((s, i) => (
                    <div key={i} className="my-3">
                      <h6 className="fw-bold">{s.heading}</h6>
                      <div dangerouslySetInnerHTML={{ __html: s.content }} />
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* EDIT MODAL */}
      {editPaper && (
        <div className="modal fade show" style={{ display: "block", background: "#0006" }}>
          <div className="modal-dialog modal-xl">
            <div className="modal-content rounded-4">

              <div className="modal-header bg-warning">
                <h5>Edit Research Paper</h5>
                <button className="btn-close" onClick={() => setEditPaper(null)}></button>
              </div>

              <div className="modal-body" style={{ maxHeight: "75vh", overflowY: "auto" }}>

                <label className="fw-bold">Title</label>
                <input
                  className="form-control mb-3"
                  value={editTitle}
                  onChange={(e) => setEditTitle(e.target.value)}
                />

                <label className="fw-bold">Abstract</label>
                <textarea
                  className="form-control mb-3"
                  rows="4"
                  value={editAbstract}
                  onChange={(e) => setEditAbstract(e.target.value)}
                />

                <label className="fw-bold">Keywords</label>
                <input
                  className="form-control mb-4"
                  value={editKeywords}
                  onChange={(e) => setEditKeywords(e.target.value)}
                />

                <h5>Researchers</h5>
                {editResearchers.map((r, index) => (
                  <div key={index} className="border rounded p-3 mb-3">

                    <label>Name</label>
                    <input
                      className="form-control mb-2"
                      value={r.name}
                      onChange={(e) => {
                        const updated = [...editResearchers];
                        updated[index].name = e.target.value;
                        setEditResearchers(updated);
                      }}
                    />

                    <label>Qualification</label>
                    <input
                      className="form-control"
                      value={r.qualification}
                      onChange={(e) => {
                        const updated = [...editResearchers];
                        updated[index].qualification = e.target.value;
                        setEditResearchers(updated);
                      }}
                    />

                  </div>
                ))}

                <h5>Sections</h5>
                {editSections.map((s, index) => (
                  <div key={index} className="border rounded p-3 mb-3">

                    <label className="fw-bold">Heading</label>
                    <input
                      className="form-control mb-2"
                      value={s.heading}
                      onChange={(e) => {
                        const updated = [...editSections];
                        updated[index].heading = e.target.value;
                        setEditSections(updated);
                      }}
                    />

                    <label className="fw-bold">Content</label>
                    <textarea
                      className="form-control"
                      rows="4"
                      value={s.content}
                      onChange={(e) => {
                        const updated = [...editSections];
                        updated[index].content = e.target.value;
                        setEditSections(updated);
                      }}
                    />

                  </div>
                ))}

              </div>

              <div className="modal-footer">
                <button className="btn btn-success px-4" onClick={handleSaveEdit}>
                  💾 Save Changes
                </button>
                <button className="btn btn-secondary" onClick={() => setEditPaper(null)}>
                  Cancel
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

    </div>
  );
}
